<template>
  <div>
    <div class="dashboard-main-content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12">
            <div class="form-box" v-if="formList != null">
              <div class="form-title-wrap">
                <div class="d-flex align-items-center justify-content-between">
                  <h3 class="title">Formlar</h3>
                </div>
              </div>
              <div class="form-content">
                <div class="table-form table-responsive" style="min-height: 400px">
                  <table class="table">
                    <thead>
                    <tr>
                      <th scope="col">Talep Saati</th>
                      <th>Acente</th>
                      <th>Durum</th>
                      <th>Rezervasyon</th>
                      <th>Aksiyon</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="form in formList" v-on:click="showDetail(form)">
                      <td >
                        {{ form.createDate | ddMMyyyyHHmm }}
                      </td>
                      <td v-if="agencyMap != null">
                        {{ agencyMap[form.agentId].name }}
                      </td>
                      <td v-else>
                        {{ agencyMap[form.agentId].name }}
                      </td>
                      <td>
                        <span v-if="form.resolveDate != null" class="badge badge-success py-1 px-2">Çözüldü</span>
                        <span v-else-if="form.claimDate == null" class="badge badge-info py-1 px-2">Beklemede</span>
                        <span v-else-if="form.claimDate != null" class="badge badge-light py-1 px-2">İşlem Yapılıyor</span>
                      </td>
                      <td>
                        <a :href="basePath+'/bookings/'+form.bookingId" target="_blank">#{{form.bookingId}}</a>
                      </td>
                      <td>
                        <div class="table-content" v-on:click="showDetail(form)">
                          <button class="theme-btn theme-btn-small" type="button" @click="showDetail(form)">
                            <i class="la la-address-book"></i>
                            .
                          </button>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-popup">
      <div v-for="booking in bookingList" class="modal fade" :id="'bookingDetayPopup-'+booking.id" tabindex="-1" role="dialog"  aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header border-bottom-0">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" class="la la-close"></span>
              </button>
            </div>
            <div class="modal-body">
              <booking-sidebar :prop-booking="booking"></booking-sidebar>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-popup">
      <div class="modal fade" :id="'bookingFormPopup'" tabindex="-1" role="dialog"  aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content" v-if="form != null">
            <div class="modal-header border-bottom-0">
              <div>
                <h5 class="modal-title">Talep Formu
                  <span v-if="form.resolveDate != null" class="badge badge-success py-1 px-2">Çözüldü</span>
                  <span v-else-if="form.claimDate == null" class="badge badge-info py-1 px-2">Beklemede</span>
                  <span v-else-if="form.claimDate != null" class="badge badge-light py-1 px-2">İşlem Yapılıyor</span>
                </h5>
              </div>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" class="la la-close"></span>
              </button>
            </div>
            <div class="modal-body">
              <div class="container-fluid form-container">
                <div class="row">
                  <div class="input-box">
                    <h6 class="title">Talep</h6>
                    <small>{{form.createDate | ddMMyyyyHHmm}}</small>
                    <br>
                    <p class="text">{{form.requestContent}}</p>
                  </div>
                </div>
                <div class="row" v-if="form.claimDate != null">
                  <div class="input-box">
                    <h6 class="title">Cevap</h6>
                    <small v-if="form.resolveDate != null">{{form.resolveDate | ddMMyyyyHHmm}}</small>
                    <br>
                    <textarea class="text" v-model="form.responseContent"></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">

              <div class="btn-box" v-if="form.claimDate == null">
                <button @click="claim(form)" class="theme-btn" type="button">Claim</button>
              </div>
              <div class="btn-box" v-if="form.claimDate != null">
                <button @click="resolve(form)" class="theme-btn" type="button">Onayla</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import BookingSidebar from "../booking/BookingSidebar";
export default {
  name: "FormList",
  components: {BookingSidebar},
  props : {
    bookingList: null,
  },
  computed:{
    formList:{
      get(){
        return this.$store.getters.getFormList;
      }
    },
    form:{
      get(){
        return this.$store.getters.getForm;
      },
      set(value){
        this.$store.commit("setForm",value)
      }
    },
    agencyMap:{
      get(){
        return this.$store.getters.getAgencyListMap;
      }
    },
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    }
  },
  methods:{
    showDetail(form){
      this.form = form;
      $("#bookingFormPopup").modal("show");
    },
    show(){
      this.$store.commit("setForm",{id:null});
    },
    claim(){
      this.$store.dispatch("claimForm", this.form)
    },
    resolve(){
      this.$store.dispatch("resolveForm", this.form).then(response => {
        Swal.fire({
          icon: 'success',
          title: 'Başarılı',
          text: '',
        })
        $(".modal").hide();
        $(".modal-backdrop").hide();
      })
    },

  },
}
</script>

<style scoped>

</style>